var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { canUseDOM } from 'exenv';
import * as React from 'react';
import { getApp } from 'navi';
import { NavContext } from './NavContext';

var NavProvider =
/** @class */
function (_super) {
  __extends(NavProvider, _super);

  function NavProvider(props) {
    var _this = _super.call(this, props) || this;

    _this.handleNavigationSnapshot = function (_a) {
      var route = _a.route;

      if (route.isSteady) {
        _this.setState({
          steadyRoute: route,
          busyRoute: undefined
        });
      } else {
        _this.setState({
          busyRoute: route
        });
      }
    };

    _this.handleError = function (error) {
      throw error;
    };

    _this.state = {};
    return _this;
  }

  NavProvider.getDerivedStateFromProps = function (props, state) {
    if (state.navigation !== props.navigation) {
      var route = props.navigation.getCurrentValue().route;
      return !route.isSteady ? {
        steadyRoute: state.steadyRoute,
        busyRoute: route,
        navigation: props.navigation
      } : {
        steadyRoute: route,
        busyRoute: undefined,
        navigation: props.navigation
      };
    }

    return null;
  };

  NavProvider.prototype.render = function () {
    var context = __assign({}, this.state, {
      onRendered: this.props.navigation.getCurrentValue().onRendered
    });

    var result = React.createElement(NavContext.Provider, {
      value: context
    }, this.props.children); // If <Suspense> is supported and the app is being rendered in a browser,
    // then wrap the app with a <Suspense> with an empty fallback, so that
    // the fallback doesn't need to be provided manually.

    var Suspense = React.Suspense;

    if (Suspense) {
      var fallback = this.props.fallback;

      if (!('fallback' in this.props) && canUseDOM && !getApp().isBuild) {
        fallback = null;
      }

      if (fallback !== undefined) {
        result = React.createElement(Suspense, {
          fallback: fallback
        }, result);
      }
    } else if (this.props.fallback !== undefined) {
      console.warn("You supplied a \"fallback\" prop to your <NavProvider>, but the version of React that you're using doesn't support Suspense. To use the \"fallback\" prop, upgrade to React 16.6 or later.");
    }

    return result;
  };

  NavProvider.prototype.componentDidMount = function () {
    this.subscribe();
  };

  NavProvider.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.navigation !== this.props.navigation) {
      this.unsubscribe();
      this.subscribe();
    }
  };

  NavProvider.prototype.componentWillUnmount = function () {
    this.unsubscribe();
  };

  NavProvider.prototype.subscribe = function () {
    if (!this.props.navigation) {
      throw new Error("A <NavProvider> component must receive a \"navigation\" prop.");
    }

    this.subscription = this.props.navigation.subscribe(this.handleNavigationSnapshot, this.handleError);
  };

  NavProvider.prototype.unsubscribe = function () {
    if (this.subscription) {
      this.subscription.unsubscribe();
      delete this.subscription;
    }
  };

  return NavProvider;
}(React.Component);

export { NavProvider };